import React from "react";
import { useEffect } from "react";
import { Button } from "../Button";
import { FiltrosContainer } from "./styles";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { ReactComponent as FilterSVG } from "../../assets/newImages/icons/filter.svg";

interface filtrosProps {
  children: React.ReactNode;
  onAplicar: () => void;
  onCancelar: () => void;
  onReset?: () => void;
  activeFiltersCount?: number;
}
export const Filtros: React.FC<filtrosProps> = ({
  children,
  onAplicar,
  onCancelar,
  onReset,
  activeFiltersCount = 0,
}) => {
  const { theme } = useTheme();

  const [dropdown, setDropdown] = React.useState(false);

  const handleOnAplicar = () => {
    onAplicar();
    setDropdown(false);
  };

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setDropdown(false);
      }
    };

    window.addEventListener("keydown", handleEsc);

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);

  return (
    <>
      <FiltrosContainer theme={theme}>
        <div
          className={`filtrosChildren fonteTexto ${
            activeFiltersCount > 0 ? "active" : ""
          }`}
          onClick={() => setDropdown(!dropdown)}
        >
          <FilterSVG />
          <div>Filtros</div>
          {activeFiltersCount > 0 && (
            <div className="filterCount">{activeFiltersCount}</div>
          )}
        </div>
        {dropdown && (
          <>
            <div
              className="fundoDropdown"
              onClick={() => setDropdown(!dropdown)}
            ></div>
            <div className="containerDropdown">
              <div className="dropdown">
                {children}                <div className="aplicarCancelar fonteTexto">
                  <div className="botoes">
                    <Button onClick={() => handleOnAplicar()} title={"Aplicar"} />
                      <Button 
                        onClick={() => {
                          if (onReset) {
                            onReset();
                          }
                          setDropdown(false);
                        }} 
                        title={"Redefinir"} 
                      />
                  </div>
                  <div
                    className="cancelar"
                    onClick={() => {
                      setDropdown(false);
                      onCancelar();
                    }}
                  >
                    Cancelar
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </FiltrosContainer>
    </>
  );
};
